<template>
  <div class="modal fade" id="import-choice-dialog" tabindex="-1" aria-hidden="true">
    <div class="modal-dialog modal-dialog-centered">
      <div class="modal-content">
        <div class="modal-header">
          <h5 class="modal-title">Import Route</h5>
          <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"></button>
        </div>
        <div class="modal-body">
          <p class="mb-3">How would you like to import this route?</p>

          <div class="choice-options">
            <div class="choice-card" :class="{ selected: selectedChoice === 'reference' }" @click="selectedChoice = 'reference'">
              <div class="choice-icon">
                <span class="material-icons">link</span>
              </div>
              <h6>Reference</h6>
              <p class="small text-muted">Any edits to this route will update it in all hikes where it's used.</p>
            </div>

            <div class="choice-card" :class="{ selected: selectedChoice === 'copy' }" @click="selectedChoice = 'copy'">
              <div class="choice-icon">
                <span class="material-icons">content_copy</span>
              </div>
              <h6>Copy</h6>
              <p class="small text-muted">Create an independent copy that can be edited separately.</p>
            </div>
          </div>
        </div>
        <div class="modal-footer">
          <button type="button" class="btn btn-secondary" data-bs-dismiss="modal">Cancel</button>
          <button type="button" class="btn btn-primary" @click="confirm" :disabled="!selectedChoice">
            Import as {{ selectedChoice === 'reference' ? 'Reference' : 'Copy' }}
          </button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent } from 'vue';

export default defineComponent({
  data() {
    return {
      selectedChoice: null,
      route: null,
      callback: null
    };
  },
  methods: {
    show(route, callback) {
      this.route = route;
      this.callback = callback;
      this.selectedChoice = null;
    },
    confirm() {
      if (this.callback && this.selectedChoice) {
        this.callback(this.selectedChoice, this.route);
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.choice-options {
  display: flex;
  gap: 1rem;
}

.choice-card {
  flex: 1;
  padding: 1.5rem;
  border: 2px solid var(--gray);
  border-radius: 8px;
  cursor: pointer;
  transition: all 0.2s;
  text-align: center;

  &:hover {
    border-color: #fddf00;
    background-color: var(--gray);
  }

  &.selected {
    border-color: #fddf00;
    background-color: var(--gray);
  }

  .choice-icon {
    margin-bottom: 0.5rem;

    .material-icons {
      font-size: 2rem;
      color: #fff;
    }
  }

  h6 {
    margin-bottom: 0.5rem;
    font-weight: 600;
  }

  p {
    margin: 0;
  }
}
</style>
